import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    OutdoorMapPlatform,
    OutdoorPlacemarkData
} from '../OutdoorMap/OutdoorMap';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './OutdoorPlacemark.css';

export interface OutdoorPlacemarkProps {
    billboard: OutdoorPlacemarkData;
}

export enum placemarkColor {
    green = '#00e000',
    blue = '#0097ff',
    red = '#ff2e39'
}

export class OutdoorPlacemark extends React.Component<OutdoorPlacemarkProps> {
    render() {
        const { billboard } = this.props;
        const slectedIds = billboard.slectedIds;
        const firstPlatform = billboard.platforms[0];
        const secondPlatform = billboard.platforms[1];
        const icon = {
            billboard: Shape2Icon.outdoorBillBoard,
            'citi-format': Shape2Icon.outdoorCitiFormat,
            'media-f': Shape2Icon.outdoorMediaF,
            'super-site': Shape2Icon.outdoorSuperSite
        }[firstPlatform.formatId];

        let background = placemarkColor.blue;
        let backgroundGradient;

        if (billboard.highlight) {
            background = placemarkColor.red;
        } else {
            const allSelected = billboard.platforms.every(platform => {
                return slectedIds.includes(platform.id);
            });

            if (allSelected) {
                background = placemarkColor.green;
            } else if (billboard.platforms.length > 1) {
                backgroundGradient = [
                    'linear-gradient(',
                    (firstPlatform.transform || 0) - 180 + 'deg',
                    ', ',
                    slectedIds.includes(firstPlatform.id)
                        ? placemarkColor.green
                        : placemarkColor.blue,
                    ' 50%',
                    ', ',
                    slectedIds.includes(secondPlatform.id)
                        ? placemarkColor.green
                        : placemarkColor.blue,
                    ' 50%',
                    ')'
                ].join('');
            }
        }

        return (
            <div
                className={Bem.cls('outdoor-placemark', '', {
                    multi: billboard.platforms.length > 1 ? 'yes' : ''
                })}
                platform-count={billboard.platforms.length}
                style={{
                    background: backgroundGradient || background
                }}
            >
                {billboard.platforms.map(
                    (platform: OutdoorMapPlatform, index) => {
                        let directionBackground = placemarkColor.blue;

                        if (billboard.highlight) {
                            directionBackground = placemarkColor.red;
                        } else if (slectedIds.includes(platform.id)) {
                            directionBackground = placemarkColor.green;
                        }

                        if (typeof platform.transform !== 'number') {
                            return <></>;
                        }

                        return (
                            <div
                                key={index}
                                className={Bem.cls(
                                    'outdoor-placemark',
                                    'direction'
                                )}
                                style={{
                                    transform:
                                        'rotate(' +
                                        (-135 + platform.transform) +
                                        'deg)',
                                    background: directionBackground
                                }}
                            />
                        );
                    }
                )}
                {icon && (
                    <Shape2
                        cls={Bem.cls('outdoor-placemark', 'icon')}
                        width={16}
                        height={16}
                        icon={icon}
                        theme={Shape2Theme.default}
                    />
                )}
            </div>
        );
    }
}
